import styled from 'styled-components'
import { colors } from 'Styled/variables'

export const StyledHint = styled.div``

export const StyledHintSign = styled.div``

export const StyledGuideWrapper = styled.div`
  display: inline-block;
  position: relative;
`

export const StyledGuide = styled.div`
  position: absolute;
  border-radius: 4px;
  transform: translate(15%, -35%);
  padding: 22px 29px;
  color: ${colors.mainText};
  background: ${colors.white};
  font-size: 14px;
  font-family: sans-serif;
  line-height: 1;
  z-index: 100;
  box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.25);
  border-radius: 8px;
  width: 329px;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
`

export const StyledDiv = styled.div`
  margin: 0 auto 20px;
`
